export const formatThousands = (value: number | null | undefined): string => {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
    value || 0
  )
}

export const formatPercentage = (value: number | null | undefined): string => {
  return new Intl.NumberFormat('en-US', { style: 'percent' }).format(value || 0)
}

export const formatAverage = (value: number | null | undefined): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value || 0)
}
